import React, { useEffect } from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Instagram as LoadingState } from 'react-content-loader';
import { useDispatch, useSelector } from 'react-redux';
import { selectRouter } from 'redux/slices/Router/RouterSlice';
import { postNetworkToken } from 'services/rest/Network/Network';
import { selectUser, setUserInfo } from 'redux/slices/userSlice';
import { getInfoUser } from 'services/rest/logout';
import Swal from 'sweetalert2';
import FacebookLogo from 'images/logos/logo-facebook.png';
import ScreenPhoto from 'images/avatars/FacebookSearch.png';
import PrivatePhoto from 'images/avatars/FacebookPrivate.png';
import { selectCompany } from 'redux/slices/Company/CompanySlice';
import Client from 'config/axios';
interface Network {
  network: string;
}

interface ITwitterAccess {
  oauth_token: string;
  oauth_verifier: string;
}

export const getAccessTokenNetwork = (resquet: string): string => {
  const getToken = resquet.split('=');
  const toClearToken = getToken[1].split('&');
  const token = toClearToken[0];
  return token;
};

export const getAccessTokenTwitter = (resquet: string): ITwitterAccess => {
  const getToken = resquet.split('=');
  const toClearToken = getToken[1].split('&');
  const token = toClearToken[0];
  return { oauth_token: token, oauth_verifier: getToken[2] };
};

export const getAccessTokenTiktok = (resquet: string): string => {
  const getToken = resquet.split('=');
  const token = getToken[1];
  return token;
};

export const getAccessTokenInstagram = (resquet: string): string => {
  const token = resquet.match(/code=([^&]+)/);
  return token ? token[1] : '';
};

const CallBack = () => {
  const { t, i18n } = useTranslation(['networks_list', 'social_network']);
  const dispatch = useDispatch();
  const history = useHistory();
  const { network } = useParams<Network>();

  const { currentUser } = useSelector(selectUser);
  const { company } = useSelector(selectCompany);
  const { router } = useSelector(selectRouter);
  const { hash, search } = useLocation();

  const getData = async (
    network: string,
    token: string,
    secret: string,
    verifier: string,
    screenName: string,
    code: string,
    facebookProfileUrl: string,
    authenticationCode: string,
    fanpageId?: string,
    isFanpage?: boolean
  ) => {
    const campaignId = localStorage.getItem('idCampaignConnect');

    await postNetworkToken(
      currentUser?.token,
      {
        token: token,
        followers: 1,
        photo: '',
        uid: 1,
        secret: secret,
        verifier: verifier,
        screenName: screenName,
        code: code,
        facebookProfileUrl: facebookProfileUrl,
        authenticationCode: authenticationCode,
        fanpageId: fanpageId,
        isFanpage: isFanpage
      },
      network
    )
      .then(response => {
        if (response.data) {
          getInfoUser(currentUser?.user?.id, currentUser?.token).then(
            response => {
              dispatch(setUserInfo(response.data));
              history.replace(campaignId ? `/campaigns/${campaignId}` : router);
            }
          );
        } else {
          history.replace(campaignId ? `/campaigns/${campaignId}` : router);
        }
      })
      .catch(error => {
        if (
          error.errors.includes('El perfil de facebook se encuentra privado')
        ) {
          Swal.fire({
            icon: 'error',
            html: `<div style="text-align: center">   
          <h4><strong>${t('networks_list:private_error')}</strong></h4>
          <div class="instruction" style="font-size: 17px;">
              <p>${t('networks_list:private_message')}</p>
          </div>
          <div class="instruction" style="font-size: 17px;">
          <button 
            onclick="window.open('https://www.facebook.com/settings/?tab=how_people_find_and_contact_you', '_blank')" 
            style="display: block; margin: 0 auto 10px auto; padding: 8px 16px; background-color: rgb(5, 85, 156); color: white; border: none; border-radius: 4px; cursor: pointer;">
            ${t('networks_list:button_text')}
          </button>
              <img style="width: 100%;" src="${PrivatePhoto}" alt="Señalando el URL en el navegador" class="image-placeholder">
          </div>`,
            confirmButtonColor: 'black'
          }).then(result => {
            if (result.isConfirmed) {
              handleFacebook();
            }
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: t('networks_list:error_title'),
            text: t('networks_list:error_message'),
            confirmButtonColor: 'black'
          }).then(result => {
            if (result.isConfirmed) {
              handleFacebook();
            }
          });
        }
      });
  };

  const handleFacebookPages = async (apiResponse: any) => {
    try {
      const fanpages = apiResponse?.fanpages || [];
      if (!Array.isArray(fanpages)) {
        throw new Error(t('networks_list:invalid_page_structure'));
      }

      if (fanpages.length === 0) {
        throw new Error(t('networks_list:no_pages_found'));
      }

      if (fanpages.length === 1) {
        return fanpages[0];
      }

      const pageOptions = fanpages.reduce((options, page) => {
        options[page.id] = page.name;
        return options;
      }, {} as Record<string, string>);

      const { value: selectedPageId } = await Swal.fire({
        title: t('networks_list:select_fanpage'),
        input: 'select',
        inputOptions: pageOptions,
        inputPlaceholder: t('networks_list:select_fanpage_placeholder'),
        showCancelButton: true,
        confirmButtonColor: 'black',
        cancelButtonColor: 'blue'
      });

      if (!selectedPageId) {
        throw new Error(t('networks_list:no_page_selected'));
      }

      const selectedPage = fanpages.find(page => page.id === selectedPageId);
      if (!selectedPage) {
        throw new Error(t('networks_list:selected_page_not_found'));
      }

      return selectedPage;
    } catch (error) {
      console.error('Error en handleFacebookPages:', error);
      throw error;
    }
  };

  const handleFacebook = async () => {
    const isFanpage =
      localStorage.getItem('facebookConnectionType') === 'fanpage';

    if (hash !== '') {
      const token = getAccessTokenNetwork(hash);

      if (isFanpage) {
        try {
          const response = await Client.post(
            'linked-social-network/facebook',
            { isFanpage: true, token: token },
            {
              headers: {
                Authorization: `Bearer ${currentUser?.token}`
              }
            }
          );
          if (response.data.data === true) {
            getData(network, token, '', '', '', '', '', '', '', true);
            return;
          }
          const pagesData = response.data?.data || response.data || [];
          if (pagesData.extraData?.fanpages) {
            const selectedPage = await handleFacebookPages(pagesData.extraData);

            getData(
              network,
              token,
              '',
              '',
              '',
              '',
              '',
              '',
              selectedPage.id,
              isFanpage
            );
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: t('networks_list:error_title'),
            text: t('networks_list:error_fanpage'),
            confirmButtonColor: 'black'
          }).then(result => {
            if (result.isConfirmed) {
              handleFacebook();
            }
          });
        }
      } else {
        // Flujo original para cuentas personales
        let userName;
        do {
          const result = await Swal.fire({
            imageUrl: FacebookLogo,
            color: 'Black',
            width: 400,
            imageWidth: 70,
            imageHeight: 70,
            input: 'text',
            showCloseButton: true,
            inputPlaceholder: t('networks_list:facebook_placeholder'),
            inputLabel: '',
            html: `<div style="text-align: center">   
            <h4><strong>${t('social_network:title')}</strong></h4>
            <div class="instruction" style="font-size: 17px;">
                <p>${t('social_network:fb_step1')}</p>
            </div>
            <div class="instruction" style="font-size: 17px;">
                <p>${t('social_network:fb_step2')}</p>        
                <img src="${ScreenPhoto}" alt="Señalando el URL en el navegador" class="image-placeholder">
            </div>
            <div class="instruction" style="font-size: 17px;">
              <p>${t('social_network:fb_step3')}</strong></p>
            </div>`,
            confirmButtonColor: 'black',
            confirmButtonText: t('networks_list:complete'),
            inputValidator: value => {
              if (!value || !value.includes('https://www.facebook.com/')) {
                return t('networks_list:facebook_error');
              }
              return null;
            }
          });

          userName = result.value;

          if (result.dismiss === Swal.DismissReason.close) {
            const campaignId = localStorage.getItem('idCampaignConnect');
            history.replace(
              campaignId ? `/campaigns/${campaignId}` : '/dashboard'
            );
            return;
          }
        } while (!userName || !userName.includes('https://www.facebook.com/'));

        getData(network, token, '', '', '', '', userName, '');
      }
    }
  };

  useEffect(() => {}, [i18n.isInitialized]);

  useEffect(() => {
    switch (network) {
      case 'facebook':
        if (company.id === 143) {
          const token = getAccessTokenNetwork(hash);
          getData(network, token, '', '', '', '', '', '');
        } else {
          handleFacebook();
        }
        break;
      case 'linkedin':
        if (search !== '') {
          const code = getAccessTokenNetwork(search);
          getData(network, '', '', '', '', code, '', '');
        }
        break;
      case 'twitter':
        if (search !== '') {
          const code = getAccessTokenTwitter(search);
          getData(
            network,
            code.oauth_token,
            '',
            code.oauth_verifier,
            '',
            '',
            '',
            ''
          );
        }
        break;
      case 'instagram':
        if (search !== '') {
          const authenticationCode = getAccessTokenInstagram(search);
          getData(network, '', '', '', '', '', '', authenticationCode);
        }
        break;
      case 'tiktok':
        if (search !== '') {
          const code = getAccessTokenTiktok(search);
          getData(network, '', '', '', '', code, '', '');
        }
        break;
    }
  }, [network, hash, search, i18n.isInitialized]);

  return <LoadingState height="230px" width="100%" />;
};

export default CallBack;
